import React, { createContext, useContext, useState } from "react";
import CustomModal from "./CustomModal"; // your SweetAlert2-style modal

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: "",
    text: "",
    text2: "",
    text3: "",
    icon: "⚠️",
    onConfirm: null,
  });

  // Function to open modal
  const openModal = (icon = "⚠️", title = "", text = "",text2="",text3="", onConfirm = null) => {
    setModalConfig({ icon, title, text, text2, text3, onConfirm });
    setShowModal(true);
  };

  // Function to close modal
  const closeModal = () => {
    if (modalConfig.onConfirm) {
      modalConfig.onConfirm();
    }
    setShowModal(false);
  };

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      <CustomModal
        show={showModal}
        title={modalConfig.title}
        text={modalConfig.text}
        text2={modalConfig.text2}
        text3={modalConfig.text3}
        icon={modalConfig.icon}
        onClose={closeModal}
      />
    </ModalContext.Provider>
  );
};

// Custom hook for convenience
export const useModal = () => useContext(ModalContext);